module.exports = {"id":"214406","name":"Albert Acevedo","rating":"72","photo":"./data/images/photos/4/214406.png","club":{"name":"CD O'Higgins","logo":"./data/images/clubs/CDO'Higgins.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlbertAcevedo0.json
// module id = 158
// module chunks = 0